import {createSelector} from 'reselect';

import {ENUM_REDUCER_STATE_ID} from './enum_constants';
import {getEnumMessageKeyFromEnumMap} from './enum_helpers';
import {EnumMap} from './enum_types';
import {RootState} from 'src/js/store';

export const getEnumMap = (state: RootState): EnumMap =>
  state[ENUM_REDUCER_STATE_ID]?.enumMap;

const getEnumName = (
  state: RootState,
  enumName: string,
  _enumValueName?: string
): string => enumName;

const getEnumValueName = (
  state: RootState,
  enumName: string,
  enumValueName: string
): string => enumValueName;

/**
 * @example
 * const enumBSIOrigin = useAppSelector((state) =>
 *   getEnumValues(state, 'BSIOrigin')
 * );
 *
 * const enumMessageKey = getEnumMessageKeyFromEnumValues('PN', enumBSIOrigin)
 */
export const getEnumValues = createSelector(
  [getEnumMap, getEnumName],
  (enumMap, enumName) => enumMap[enumName]
);

/**
 * @example
 * const enumBSIOriginSSIMessageKey = useAppSelector((state) =>
 *   getEnumValue(state, 'BSIOrigin', 'SSI')
 * );
 */
export const getEnumValue = createSelector(
  [getEnumMap, getEnumName, getEnumValueName],
  (enumMap, enumName, enumValueName) =>
    getEnumMessageKeyFromEnumMap(enumMap, enumName, enumValueName)
);
